// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7) return "static/chunks/7-694f1e16c0798c75.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3945":"c518b2dee3d76098","4095":"d7e810a0639c375c"}[chunkId] + ".js";
};